import CheckIcon from '@mui/icons-material/Check'
import { IconButton, Stack } from '@mui/material'

import { COLORS } from './constants'

interface ColorPickerProps {
  value?: string
  onChange: (color: string) => void
  disabled?: boolean
}

function ColorPicker({ onChange, value, disabled }: ColorPickerProps) {
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {COLORS.map(color => (
        <IconButton
          key={color}
          disabled={disabled}
          onClick={() => onChange(color)}
          sx={{
            backgroundColor: color,
            width: 40,
            height: 40,
            '&:hover': { backgroundColor: color, opacity: 0.8 },
            position: 'relative',
          }}
        >
          {color === value && (
            <CheckIcon
              sx={{ color: 'white', fontSize: 20, position: 'absolute' }}
            />
          )}
        </IconButton>
      ))}
    </Stack>
  )
}

export default ColorPicker
